import React from "react"
import { RouteComponentProps } from "@reach/router"
import { GlobalOverflowHidden } from "./styles/UnauthStyles"
import { IFrame } from "../integration/iframe"

interface Props extends RouteComponentProps {
  secret?: string
}

export const ClaimSubmissions: React.FC<Props> = ({ path = ``, secret = `` }) => (
  <>
    <GlobalOverflowHidden />
    <IFrame path={path.replace(`:secret`, secret)} />
  </>
)

ClaimSubmissions.defaultProps = {
  secret: ``,
}
